export default __webpack_public_path__ + "static/media/need-help-email.011fffcf.svg";